// extracted by css-extract-rspack-plugin
export default {"cls1":"MentionsCardHeader-cls1_QcZ","cls2":"MentionsCardHeader-cls2_M4W MentionsCardHeader-cls1_QcZ"};